export const sectionMenus = {
  intro: [
    { label: "인사말", link: "/intro/intro" },
    { label: "샵", link: "/intro/shop" },
    { label: "오시는길", link: "/intro/location" },
  ],
  hair: [
    { label: "디자이너", link: "/hair/list" },
    { label: "트렌드", link: "/hair/trend" },
    { label: "갤러리", link: "/hair/gallery" },
  ],
  makeUp: [
    { label: "디자이너", link: "/makeUp/list" },
    { label: "트렌드", link: "/makeUp/trend" },
    { label: "갤러리", link: "/makeUp/gallery" },
  ],
  wedding: [
    { label: "트렌드", link: "/wedding/trend" },
    { label: "갤러리", link: "/wedding/gallery" },
  ],
  star: [
    { label: "매거진", link: "/star/magazine" },
    { label: "뮤비X앨범", link: "/star/music" },
    { label: "광고", link: "/star/advertisement" },
  ],
  nailArt: [
    { label: "디자이너", link: "/nailArt/list" },
    { label: "트렌드", link: "/nailArt/trend" },
    { label: "갤러리", link: "/nailArt/gallery" },
  ],
  csc: [
    { label: "공지사항", link: "/csc/notice" },
    { label: "채용안내", link: "/csc/recruit" },
  ],
};
